import * as React from 'react'
import { IStationUserGoinZoneObject } from '../../../types'
import EyeSee from '../../icons/ui/EyeSee'
import EyeUnsee from '../../icons/ui/EyeUnsee'
import ContextMenu from '../../ui/ContextMenu'
import Edit from 'src/components/icons/drivers/Edit'
import TrashIcon from '../../icons/ui/Trash'
import { Link } from 'react-router-dom'
import UIMessages from 'src/utils/ui-messages'

interface IoinZonesListItemProps {
  zone: IStationUserGoinZoneObject
  map: any
  setZoneVisible: (zone: IStationUserGoinZoneObject, visible: boolean) => void
  onEditZone: (zone: IStationUserGoinZoneObject) => Promise<any>
  match: any
  centerTo: (center: any, zoom?: number | null) => void
  viewMode?: boolean
}

class GoinZonesListItem extends React.Component<IoinZonesListItemProps, any> {
  public render() {
    const { zone, viewMode } = this.props
    const style: any = {
      display: 'inline-block',
      width: '24px',
      height: '24px',
      backgroundColor: zone.color,
      marginTop: 'auto',
      marginBottom: 'auto',
      marginRight: '4px',
      border: '2px solid black',
      cursor: 'pointer'
    }
    const { edit, deleteLabel } = UIMessages.common
    return (
      <div style={{ height: '48px', lineHeight: '48px' }} className='flex'>
        <span onClick={this.focus} style={style} className='rounded' />
        <div className='cursor--pointer h5 pl1' onClick={this.focus}>
          {zone.name}
        </div>
        <div style={{ marginLeft: 'auto' }}>
          <div className='flex' style={{ width: '100%', height: '100%' }}>
            <div className='flex items-center'>
              {zone.visible && (
                <div style={{ cursor: 'pointer' }} onClick={this.onSetInvisible}>
                  <EyeSee style={{ margin: 'auto' }} className='mr1 block' />
                </div>
              )}
              {!zone.visible && (
                <div style={{ cursor: 'pointer' }} onClick={this.onSetVisible}>
                  <EyeUnsee style={{ margin: 'auto' }} className='mr1 block' />
                </div>
              )}
              {!viewMode && (
                <div style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                  <ContextMenu className='ListItemMenu '>
                    <div onClick={this.onEdit} className='MenuItem cursor--pointer pl2'>
                      <div className='flex items-center'>
                        <Edit className='mr02 svg-stroke-light-grey' />
                        <div className='pl1'>{edit}</div>
                      </div>
                    </div>
                    <div className='MenuItem cursor--pointer pl1'>
                      <Link className='flex items-center' to={`${this.props.match.path}/remove-zone/${zone.id}`}>
                        <TrashIcon className='svg-stroke-light-grey' />
                        <div className='pl1'>{deleteLabel}</div>
                      </Link>
                    </div>
                  </ContextMenu>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  private focus = () => {
    this.props.centerTo(this.props.zone.coordinates, 8)
  }

  private onEdit = () => {
    this.props.onEditZone(this.props.zone)
  }

  private onSetInvisible = () => {
    this.props.setZoneVisible(this.props.zone, false)
  }

  private onSetVisible = () => {
    this.props.setZoneVisible(this.props.zone, true)
  }

  private getPinSymbol = (color: string) => {
    return (
      <div onClick={this.focus} style={{ marginLeft: '-5px', cursor: 'pointer' }}>
        <svg
          width={'36px'}
          height={'36px'}
          viewBox='-24 -48 48 48'
          xmlns='http://www.w3.org/2000/svg'
          style={{ overflow: 'visible', display: 'block', margin: 'auto' }}
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z'
            fill={color}
            fillOpacity={1}
            stroke={'#000'}
            strokeWidth={2}
            scale={1}
          />
        </svg>
      </div>
    )
  }
}

export default GoinZonesListItem



// WEBPACK FOOTER //
// ./src/components/station-user/view/GoinZonesListItem.tsx